export const scrollToBottom = (scrollContainerRef) => {
  requestAnimationFrame(() => {
    const container = scrollContainerRef?.current;
    if (!container) return;

    container.scrollTop = container.scrollHeight;
  });
};
